const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const edgeFnBase = `${supabaseUrl}/functions/v1/llm-api`;

export const edgeFnHeaders = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${supabaseAnonKey}`,
};

export function placePhotoUrl(photoName: string, maxHeightPx = 300, maxWidthPx = 300): string {
  const encoded = encodeURIComponent(photoName);
  const params = new URLSearchParams({
    maxHeightPx: String(maxHeightPx),
    maxWidthPx: String(maxWidthPx),
    apikey: supabaseAnonKey,
  });
  return `${edgeFnBase}/place-photo/${encoded}?${params.toString()}`;
}

export function staticMapUrl(lat: number, lng: number, zoom = 15, size = '600x300', cacheOnly = false): string {
  const center = `${lat},${lng}`;
  const markers = `color:red|${lat},${lng}`;
  const params = new URLSearchParams({
    center,
    zoom: String(zoom),
    size,
    markers,
    apikey: supabaseAnonKey,
  });
  if (cacheOnly) {
    params.set('cacheOnly', 'true');
  }
  return `${edgeFnBase}/static-map?${params.toString()}`;
}
